var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIcon14(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4668",
    "data-name": "Group 4668",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.933,
    height: 23.749,
    viewBox: "0 0 37.933 23.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1669",
    "data-name": "Rectangle 1669",
    width: 37.933,
    height: 23.749,
    fill: "#ff9ee0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4667",
    "data-name": "Group 4667",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14067",
    "data-name": "Path 14067",
    d: "M23.763,11.881a11.98,11.98,0,0,0-4.742-9.5.187.187,0,0,0-.054-.041,11.877,11.877,0,1,0-7.085,21.405,11.8,11.8,0,0,0,7.085-2.344.187.187,0,0,0,.054-.041,11.917,11.917,0,0,0,1.5-1.355,11.754,11.754,0,0,0,3.238-8.129M17.409,20.01a9.676,9.676,0,0,1-5.527,1.707A9.842,9.842,0,1,1,17.409,3.739a.187.187,0,0,1,.054.041,9.016,9.016,0,0,1,1.5,1.273,9.8,9.8,0,0,1,0,13.642,9.016,9.016,0,0,1-1.5,1.273c-.014.027-.027.041-.054.041",
    transform: "translate(0 0)",
    fill: "#ff9ee0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14068",
    "data-name": "Path 14068",
    d: "M20.865,0A11.825,11.825,0,0,0,14.62,1.775c.014.014.041.027.054.041a12.279,12.279,0,0,1,1.49,1.409h.014a9.752,9.752,0,0,1,4.687-1.192,9.842,9.842,0,1,1,0,19.685,9.752,9.752,0,0,1-4.687-1.192h-.014a11.31,11.31,0,0,1-1.49,1.409c-.014.014-.041.027-.054.041A11.876,11.876,0,1,0,20.865,0",
    transform: "translate(5.187 0)",
    fill: "#ff9ee0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14069",
    "data-name": "Path 14069",
    d: "M13.129,3.331c-.027-.014-.041-.027-.068-.041a11.876,11.876,0,0,0,0,14.835c.027-.014.041-.027.068-.041a7.954,7.954,0,0,0,1.49-1.287,9.781,9.781,0,0,1,0-12.179,9.089,9.089,0,0,0-1.49-1.287",
    transform: "translate(3.711 1.167)",
    fill: "#ff9ee0"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon14);
export default __webpack_public_path__ + "static/media/media_icon14.5cd93a866f5be9cf67b13c9a7d095abe.svg";
export { ForwardRef as ReactComponent };